import { render, staticRenderFns } from "./waterqueryDetial.vue?vue&type=template&id=fb3d865c&scoped=true&"
import script from "./waterqueryDetial.vue?vue&type=script&lang=js&"
export * from "./waterqueryDetial.vue?vue&type=script&lang=js&"
import style0 from "./waterqueryDetial.vue?vue&type=style&index=0&id=fb3d865c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3d865c",
  null
  
)

export default component.exports